import React from 'react'
import { Dimmer, Loader } from 'semantic-ui-react'
import PropTypes from 'prop-types'

const PageLoader = ({ active, content = 'Loading...', size = 'large', inverted = true }) => {
  return (
    <Dimmer active={active} page>
      <Loader 
        size={size}
        inverted={inverted}
        content={content}
      />
    </Dimmer>
  )
}

PageLoader.propTypes = {
  active: PropTypes.bool.isRequired,
  content: PropTypes.string,
  size: PropTypes.oneOf(['mini', 'tiny', 'small', 'medium', 'large', 'huge']),
  inverted: PropTypes.bool
}

export default PageLoader 